var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container bp-header"},[_c('div',{staticClass:"content bp-header__content"},[_c('img',{attrs:{"src":_vm.logo}}),_c('div',[_c('app-request-access-link',[_c('cs-button',{attrs:{"fill":"outline","corners":"rounded"}},[_vm._v("Request Access")])],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }